<section class="page">
  <header class="page-header">
    <div>
      <h1>Webhook logs</h1>
      <p>Every webhook — Kobble audit, Stripe audit, and HTTP access logs</p>
    </div>
  </header>

  @if (error()) {
    <div class="alert alert-error">{{ error() }}</div>
  }

  <div class="panel filters">
    <div class="filter-grid">
      <label>
        <span>Provider</span>
        <select [(ngModel)]="provider">
          <option value="all">All webhooks</option>
          <option value="kobble">Kobble audit</option>
          <option value="stripe">Stripe audit</option>
          <option value="http">HTTP access</option>
        </select>
      </label>
      <label>
        <span>Status</span>
        <select [(ngModel)]="status">
          <option value="">Any</option>
          <option value="received">received</option>
          <option value="processing">processing</option>
          <option value="processed">processed</option>
          <option value="failed">failed</option>
          <option value="ignored">ignored</option>
          <option value="duplicate">duplicate</option>
        </select>
      </label>
      <label>
        <span>Event type</span>
        <input type="text" [(ngModel)]="eventType" placeholder="transaction-accept" (keyup.enter)="applyFilters()" />
      </label>
      <label>
        <span>Search</span>
        <input type="text" [(ngModel)]="q" placeholder="event id, entity, error…" (keyup.enter)="applyFilters()" />
      </label>
    </div>
    <div class="filter-actions">
      <button class="btn btn-primary" type="button" (click)="applyFilters()" [disabled]="loading()">Search</button>
      <button class="btn btn-secondary" type="button" (click)="clearFilters()" [disabled]="loading()">Clear</button>
    </div>
  </div>

  <div class="panel">
    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Provider</th>
            <th>Event</th>
            <th>Entity</th>
            <th>Status</th>
            <th>Signature</th>
            <th>Received</th>
          </tr>
        </thead>
        <tbody>
          @if (loading()) {
            <tr><td colspan="7" class="muted">Loading…</td></tr>
          } @else if (!rows().length) {
            <tr><td colspan="7" class="muted">No webhook logs</td></tr>
          } @else {
            @for (row of rows(); track (row.log_source || '') + '-' + row.provider + '-' + row.id) {
              <tr
                class="clickable"
                [routerLink]="['/webhook-logs', row.provider, row.id]"
                [queryParams]="{ source: row.log_source || null }"
              >
                <td>{{ row.id }}</td>
                <td>
                  <div>{{ row.provider }}</div>
                  <div class="muted">{{ sourceLabel(row.log_source) }}</div>
                </td>
                <td>
                  <div>{{ row.event_type || '—' }}</div>
                  <div class="muted mono">{{ row.event_id || '—' }}</div>
                </td>
                <td>
                  <div>{{ row.entity_type || '—' }}</div>
                  <div class="muted mono">{{ row.entity_id || '—' }}</div>
                </td>
                <td>
                  <span class="badge" [attr.data-status]="row.status">{{ row.status || '—' }}</span>
                </td>
                <td>
                  @if (row.signature_valid === true) { valid }
                  @else if (row.signature_valid === false) { invalid }
                  @else { — }
                </td>
                <td>{{ row.received_at ? (row.received_at | date: 'medium') : '—' }}</td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>

    <div class="pager">
      <span class="muted">Page {{ page() }} of {{ totalPages() }} · {{ total() }} total</span>
      <div class="pager-actions">
        <button class="btn btn-secondary" type="button" (click)="prev()" [disabled]="page() <= 1 || loading()">
          Previous
        </button>
        <button
          class="btn btn-secondary"
          type="button"
          (click)="next()"
          [disabled]="page() >= totalPages() || loading()"
        >
          Next
        </button>
      </div>
    </div>
  </div>
</section>
